import { parseZonedDateTime } from '@rematter/common/dateTime';
import { Subscription } from '@rematter/frontend-lib-api-client/graphql/schema';

import { NotificationFeedEntry } from '~/modules/notifications/types';
import { createSubscriptionHook } from '~/shared/providers/api';

export const useNotificationReceivedSubscription = createSubscriptionHook(
  'notifications.received',
  (_: void) => ({
    notificationReceived: {
      id: true,
      notification: {
        id: true,
        eventId: true,
        notificationTypeKey: true,
        actorId: true,
        resourceType: true,
        resourceId: true,
        title: true,
        body: true,
        actionLink: true,
      },
      channel: true,
      isRead: true,
      isSeen: true,
      isArchived: true,
      readAt: true,
      seenAt: true,
      timestamps: {
        createdAt: true,
      },
    },
  }),
  {
    select: ({
      notificationReceived: entry,
    }: Pick<Subscription, 'notificationReceived'>): NotificationFeedEntry => ({
      id: entry.id,
      notification: {
        id: entry.notification.id,
        eventId: entry.notification.eventId,
        notificationTypeKey: entry.notification.notificationTypeKey,
        actorId: entry.notification.actorId ?? undefined,
        resourceType: entry.notification.resourceType,
        resourceId: entry.notification.resourceId,
        title: entry.notification.title,
        body: entry.notification.body,
        actionLink: entry.notification.actionLink ?? undefined,
      },
      channel: entry.channel,
      isRead: entry.isRead,
      isSeen: entry.isSeen,
      isArchived: entry.isArchived,
      readAt: entry.readAt ? parseZonedDateTime(entry.readAt) : undefined,
      seenAt: entry.seenAt ? parseZonedDateTime(entry.seenAt) : undefined,
      createdAt: parseZonedDateTime(entry.timestamps.createdAt),
    }),
  },
);
